import { ref } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { store } from "../store/ShomeiEntryStore";
const log = Log.create("Shomei.load");
export const useLoad = (shomeiNo) => {
    const loading = ref(false);
    const load = async () => {
        try {
            loading.value = true;
            await store.load(shomeiNo);
        }
        catch (ex) {
            log.error("load", ex);
            MsgBox.error(ex.message);
        }
        finally {
            loading.value = false;
        }
    };
    return {
        loading,
        load
    };
};
